import { useContext } from "react";
import { styled } from "styled-components";
import { AccountContext } from "./account-context";
import { PlatformIcon } from "../plaform-icon/plaform-icon";
import { getPlatformName } from "../../../../utils/accounts";
import {
  AccountPlatformType,
  platformAccountNameMap,
  PlatformName,
} from "../../../../shared/types/accounts";
import { PlatformNameToPlatformTypeMap } from "../../../../features/post/format-post";
import youtubeIconUtils from "../../../../utils/youtube-icon-utils";
import { getAccountPlatformType } from "../../libs/account-platform";

type AccountPlatformIconProps = {
  account?: {
    platformId?: string | null;
    platformType?: AccountPlatformType;
  };
  className?: string;
  useYtRedPlayIcon?: boolean;
};

export const AccountPlatformIcon = styled((props: AccountPlatformIconProps) => {
  const account = props.account || useContext(AccountContext);

  let platformType = getPlatformName(getAccountPlatformType(account));

  const hasPlatform = Boolean(account?.platformId);
  const otherTypesWithConnectionOptions = [
    PlatformNameToPlatformTypeMap.tiktok,
    PlatformNameToPlatformTypeMap.threads,
  ];
  const isOtherTypeWithConnectionOption =
    account?.platformType &&
    otherTypesWithConnectionOptions.includes(account.platformType);

  if (isOtherTypeWithConnectionOption && !hasPlatform) {
    platformType = platformAccountNameMap.OT;
  }

  if (props.useYtRedPlayIcon && platformType === "youtube") {
    platformType = youtubeIconUtils.resolveYtRedIcon(
      platformType
    ) as PlatformName;
  }

  return <PlatformIcon className={props.className} type={platformType} />;
})``;
